import { useEffect, useState } from "react";
import { _MassMail, _single } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../theme/Component/BasicPage"
import { FileInput } from "../../theme/Component/FileInput";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { ListMenu } from "../../theme/Component/ListMenu";
import { MassEmailItem } from "./MassEmailItem";

export const MassEmail = () => {

    const _massEmail = useDataBean(_MassMail);
    const { lista, getLista, bean, setBean, handleChange, getListaLike } = _massEmail;
    const [data, setData] = useState<any>({});
    const modalAdd = useModal("Masivo", MODAL_md);
    const modalItems = useModal("Items", MODAL_LG);

    useEffect(() => {
        getLista({}, null);
    }, [])

    const cargarArchivos = () => {
        console.log(bean);
        _massEmail.update().then(
            (resp: any) => {
                getListaLike({}, null);
                modalAdd.close();
            }
        );
    }

    const agregar = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID()
        });
        modalAdd.open();
    }
    const deleteItem = () => {
        _massEmail.deleteItem(bean.IDMassMail).then((resp: any) => {

            getLista({}, null);
        })
    }

    const head = [
        { title: 'ID', property: 'IDMassMail', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Mensaje', property: 'MessageText', visible: true }
    ]
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregar }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver items', icono: 'ri-file-list-line', visible: true, evento: () => { modalItems.open() } },
            { titulo: 'Editar', icono: 'ri-edit-line', visible: true, evento: () => modalAdd.open() },
            { titulo: 'Eliminar', icono: 'ri-eraser-fill', visible: true, evento: deleteItem },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Email Masivo">
            <div className="row">




            </div>
            <div className="row">
                <div className="col-md-12">
                    <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} ></BasicTable>
                    <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={cargarArchivos} onSubmitLabel="Crear">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nombre del proceso</label>
                                <input type="text" className="form-control" value={bean.Name} name="Name" onChange={handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Mensaje</label>
                                <textarea className="form-control" name="MessageText" value={bean.MessageText} onChange={handleChange}></textarea>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal}>
                        <MassEmailItem massEmail={bean} />
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}